import { render, staticRenderFns } from "./Home-admin.vue?vue&type=template&id=c6d45c5e&scoped=true"
import script from "./Home-admin.vue?vue&type=script&lang=js"
export * from "./Home-admin.vue?vue&type=script&lang=js"
import style0 from "./Home-admin.vue?vue&type=style&index=0&id=c6d45c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d45c5e",
  null
  
)

export default component.exports